import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { useAuth } from "@clerk/react";
import { AppLoading, AppErrorBoundary } from "@/components/AppState";
import { Toaster } from "sonner";
import ClerkAuthProvider from "@/components/auth/ClerkAuthProvider";
import { LangProvider } from "@/lib/i18n";
import Landing from "@/pages/Landing";
import AuthPage from "@/pages/AuthPage";
import DashboardLayout from "@/components/layout/DashboardLayout";
import Overview from "@/pages/Overview";
import Agents from "@/pages/Agents";
import Knowledge from "@/pages/Knowledge";
import Channels from "@/pages/Channels";
import Streams from "@/pages/Streams";
import StreamRoom from "@/pages/StreamRoom";
import Analytics from "@/pages/Analytics";
import Billing from "@/pages/Billing";
import Settings from "@/pages/Settings";
import PaymentResult from "@/pages/PaymentResult";
import YouTubeStudio from "@/pages/YouTubeStudio";
import Admin from "@/pages/admin/Admin";

const Protected = ({ children }) => {
  const { isLoaded, isSignedIn } = useAuth();
  if (!isLoaded) return <AppLoading />;
  return isSignedIn ? children : <Navigate to="/sign-in" replace />;
};

function App() {
  return (
    <div className="App">
      <AppErrorBoundary>
      <LangProvider>
        <BrowserRouter>
          <ClerkAuthProvider>
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/sign-in/*" element={<AuthPage mode="sign-in" />} />
              <Route path="/sign-up/*" element={<AuthPage mode="sign-up" />} />
              <Route path="/payment/:result" element={<Protected><PaymentResult /></Protected>} />
              <Route path="/dashboard" element={<Protected><DashboardLayout /></Protected>}>
                <Route index element={<Overview />} />
                <Route path="agents" element={<Agents />} />
                <Route path="knowledge" element={<Knowledge />} />
                <Route path="channels" element={<Channels />} />
                <Route path="youtube" element={<YouTubeStudio />} />
                <Route path="streams" element={<Streams />} />
                <Route path="streams/:id" element={<StreamRoom />} />
                <Route path="analytics" element={<Analytics />} />
                <Route path="billing" element={<Billing />} />
                <Route path="settings" element={<Settings />} />
                <Route path="admin" element={<Admin />} />
              </Route>
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </ClerkAuthProvider>
        </BrowserRouter>
        <Toaster theme="dark" position="top-right" richColors />
      </LangProvider>
      </AppErrorBoundary>
    </div>
  );
}

export default App;
